import { RingBadge } from '@/components/Badge/Badge'
import { ItemList, type ItemListProps } from '@/components/ItemList/ItemList'
import { groupItemsByRing } from '@/lib/data'
import { cn } from '@/lib/utils'
import type { Item } from '../../../../types'
import styles from './RingList.module.css'

interface RingListProps {
  items: readonly Item[]
  size?: ItemListProps['size']
}

export function RingList({ items, size }: RingListProps) {
  const rings = groupItemsByRing(items)

  return (
    <ul
      className={cn(styles.rings, { [styles.isSmall]: size === 'small' })}
      data-testid="ring-list"
    >
      {Object.entries(rings).map(([ring, items]) => {
        return (
          <li
            key={ring}
            className={styles.ring}
            data-testid={`ring-list-item-${ring}`}
          >
            <div className={styles.header} data-testid="ring-list-header">
              <RingBadge className={styles.badge} ring={ring} />
            </div>
            <ItemList
              className={styles.list}
              items={Array.isArray(items) ? items : []}
              size={size}
            />
          </li>
        )
      })}
    </ul>
  )
}
